const DetailsEndpointFetchPrescriptionsRequestHttpQueryParams = (request) => {
    return {
        primary_prescription_id: request.primary_prescription_id,
        page_size: request.pagination?.page_size,
        page_token: request.pagination?.page_token,
    };
};
export const DetailsEndpoint = (makeRequest) => {
    return {
        // Fetch the Medication Details related to the prescription_id
        fetchMedication(params, options) {
            return makeRequest('GET', '/v1/medications/details/fetch_medication', params, options);
        },
        // Fetch the additional MedDetailsPrescriptions for the medication related to the primary prescription id
        fetchPrescriptions(params, options) {
            return makeRequest('GET', '/v1/medications/details/fetch_prescriptions', DetailsEndpointFetchPrescriptionsRequestHttpQueryParams(params), options);
        },
    };
};
//# sourceMappingURL=details_endpoint.js.map